/* eslint-disable import/no-anonymous-default-export */
import { User } from '../../types/types';
import { UsersEdit } from './UserEdit';
import { UsersList } from './UserList';

export default {
    list: UsersList,
    edit: UsersEdit,
    recordRepresentation: (record: User) =>
        `${record.first_name} ${record.last_name}`,
};
